import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-40 md:pt-44 pb-20 overflow-hidden bg-ink" data-id="element-91" data-mp="ej4mbu3165dv">
      {/* Ultra-premium architectural background */}
      <div className="absolute inset-0 z-0" data-id="element-92" data-mp="4lyx6rdz8oga">
        <img src="https://cdn.magicpatterns.com/uploads/aDAXFqEKdWDQxSN4cV7bYm/ChatGPT_Image_Jun_12,_2026,_01_27_34_PM.png" alt="Luxury modern kitchen and dining interior with marble island and fireplace" className="w-full h-full object-cover object-center md:object-[55%_center]" data-id="element-93" data-mp="4n9ymkjy9k48" />
        {/* Horizontal overlay: stronger on the left for headline contrast, lighter on the right to reveal the architecture */}
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(90deg, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.52) 40%, rgba(0,0,0,0.25) 70%, rgba(0,0,0,0.12) 100%)'
      }} data-id="element-94" data-mp="3d1a8hk3o4bda"></div>
        {/* Subtle vertical overlay for top/bottom legibility */}
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, rgba(0,0,0,0.28) 0%, rgba(0,0,0,0.12) 45%, rgba(0,0,0,0.45) 100%)'
      }} data-id="element-95" data-mp="3o7vk1k75dnxa"></div>
      </div>

      <div className="container mx-auto px-8 lg:px-12 relative z-10" data-id="element-96" data-mp="3e7l6fyh7aehl">
        <div className="max-w-4xl" data-id="element-97" data-mp="30gzvcvxzn8u9">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex items-center gap-4 mb-8" data-id="element-98" data-mp="30fy7trzsctvn">
            <div className="w-8 h-[1px] bg-lime" data-id="element-99" data-mp="2hk83vz8alnf4"></div>
            <span className="text-paper/80 font-body text-xs uppercase tracking-[0.3em]" data-id="element-100" data-mp="2hljb690y5daz">
              Clean Spaces. Zero Drama.
            </span>
          </motion.div>

          <motion.h1 className="text-4xl md:text-5xl lg:text-6xl text-paper leading-[1.15] mb-8 font-light" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.1,
          ease: 'easeOut'
        }} data-id="element-101" data-mp="s3cla9fddhq1">
            Professional Cleaning Services <br className="hidden md:block" data-id="element-102" data-mp="161jal16969e3" />
            <span className="font-medium" data-id="element-103" data-mp="162m3tfr1snx6">
              in Orlando, Kissimmee & Broward, FL
            </span>
          </motion.h1>

          <motion.p className="text-lg md:text-xl text-concrete/90 font-light mb-12 max-w-2xl tracking-wide" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-104" data-mp="x1ee3m2lkvep">
            We don't clean.{' '}
            <span className="text-paper font-normal" data-id="element-105" data-mp="21b66k5ekreqc">We reset spaces.</span>
          </motion.p>

          <motion.div className="flex flex-col sm:flex-row gap-6" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: 'easeOut'
        }} data-id="element-106" data-mp="268ofvwwi7vyv">
            <a href="#quote" className="bg-paper text-ink px-8 py-4 text-xs uppercase tracking-[0.2em] hover:bg-concrete transition-colors text-center flex items-center justify-center" data-id="element-107" data-mp="2p10dk6c7q92o">
              Get a Free Quote
            </a>

            <a href="https://wa.me/19548181392" target="_blank" rel="noopener noreferrer" className="border border-paper/30 text-paper px-8 py-4 text-xs uppercase tracking-[0.2em] hover:bg-paper/10 transition-colors text-center flex items-center justify-center gap-3 group" data-id="element-108" data-mp="zmluo2nvlgf3">
              <MessageCircle size={16} className="text-lime group-hover:scale-110 transition-transform" strokeWidth={1.5} data-id="element-109" data-mp="e7h8pdeunmor" />
              <span data-id="element-110" data-mp="3hqk1qjv1r0ad">Text Us on WhatsApp</span>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}